import { render, staticRenderFns } from "./CreateBuyerCustomer.vue?vue&type=template&id=107488d9&"
import script from "./CreateBuyerCustomer.vue?vue&type=script&lang=js&"
export * from "./CreateBuyerCustomer.vue?vue&type=script&lang=js&"
import style0 from "./CreateBuyerCustomer.vue?vue&type=style&index=0&id=107488d9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports